// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

class About extends React.Component {
	render() {
		return (
			<div className="page-about-extra">
				<div className="page-about-services">
					<div className="-inner">
						<div className="-heading">
							<h2 className="subtitle">Services</h2>
						</div>

						<div className="-links">
							<div>
								<h3><Link to="/websites">Web design</Link></h3>
								<h3><Link to="/websites">App design</Link></h3>
								<h3><Link to="/websites">User interface design</Link></h3>
							</div>

							<div>
								<h3><Link to="/websites">User experience design</Link></h3>
								<h3><Link to="/branding">Brand identity</Link></h3>
								<h3><Link to="/graphic-design">Graphic design</Link></h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		page: state.page.selected
	}
}

export default connect( mapStateToProps )( About )



// WEBPACK FOOTER //
// ./views/pages/About.jsx